export default __webpack_public_path__ + "static/media/get-down-wit-yo-bad-self.ee1656fe.gif";